import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const dcTraderSiteSchema = baseObjectSchema.extend({
  traderSiteId: z.string(),
  representativeId: z.string().optional(),
  traderSiteRemotedCode: z.string(),
  traderSite: z
    .object({
      id: z.string(),
      name: z.string(),
      code: z.string().optional(),
      traderId: z.string(),
    })
    .optional(),
});

export const getDCTraderSitesResponseSchema = z.object({
  data: z.array(dcTraderSiteSchema),
  count: z.number(),
});

export type GetDCTraderSitesResponse = z.infer<typeof getDCTraderSitesResponseSchema>;
